import React, { PureComponent, Children } from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Form from '../../components/ResponsiveForm'
import Image from '@stackhouse/dashboard-components/Image'
import Button from '@stackhouse/dashboard-components/Button'

import ForgotPassword from './forgotPassword'
import Loader from '@stackhouse/dashboard-components/Loader'
import { Fragment } from 'react'


const fields = {
    username: {
        group: 1,
        type: 'text',
        label: 'Username',
        id: 'username',
        required: true,
    },
    password: {
        group: 2,
        type: 'text',
        id: 'password',
        label: 'Password',
        password: true,
        required: true,
    },
}


export default class Login extends PureComponent {

    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = { fields: null }
    }

    forgotPassword = () => {
        const { client, withLoader } = this.props
        return ForgotPassword({
            client,
            withLoader
        })
    }

    keyDownPassword = (event) => {
        if (event.key == 'Enter') {
            return this.login()
        }
    }

    componentDidMount() {
        return this.setState({
            fields: {
                ...fields,
                password: { ...fields.password, onKeyDown: this.keyDownPassword },
            }
        })
    }

    login = () => {
        const { client, setUser, history, withLoader } = this.props
        if (this.formRef.current.isValid()) {
            return withLoader(done => {
                return client.post('/user', this.state.value).then(({ data: user }) => {
                    return setUser(user, user.accessToken.accessToken, () => {
                        return history.replace({ pathname: '/index' })
                    })
                }).then(done).catch(done)
            })
        }
    }

    onChange = (value) => {
        return this.setState({ value })
    }

    render() {
        const { fields, value } = this.state
        const { settings: { login: { logo, background } = {} } = {} } = this.props
        return (
            <Flex fill row>
                <Flex column flex={1} padding={'5%'}>
                    <Image contain width={'80%'} maxWidth={200} alignSelf={[undefined, 'center']} src={logo} marginBottom={'5%'} />
                    <Flex flex={1} alignCenter justifyCenter paddingBottom={'20%'}>
                        <Flex column alignCenter justifyCenter>
                            {fields
                                ? (
                                    <Fragment>
                                        <Form ref={this.formRef} fields={fields} value={value} onChange={this.onChange} />
                                        {/* <Button link alignSelf={'flex-end'} padding={0} mt={'0.25em'} fontSize={'0.95em'} title={'Forgot password?'} onClick={this.forgotPassword} /> */}
                                        <Button width={'50%'} marginTop={'2em'} title={'LOGIN'} onClick={this.login} />
                                    </Fragment>
                                )
                                : (
                                    <Loader />
                                )}
                        </Flex>
                    </Flex>
                </Flex>
                <Flex column flex={[1, '0 1 0']}>
                    <Image fill cover src={background} />
                </Flex>
            </Flex>
        )
    }

}